import { getAutodeskTeams, getAutodeskUserProfile, retriedGetAutodeskContext, } from '@innovyze/stylovyze/lib/services/forge.service';
import { getTenantId, setTenantId, } from '@innovyze/stylovyze/lib/storages/tenantId';
import { setDefaultSite, setDefaultSiteName, setTeams, setToken, setUser, } from '@innovyze/stylovyze/lib/actions/authenticationContext.actions';
import { processUserContextToStore } from '@innovyze/stylovyze/lib/utils/UserContext';
import { setUserContext } from '@innovyze/stylovyze/lib/actions/userContext.actions';
import { useDispatch } from 'react-redux';
export const useForgeUserContext = (config) => {
    const dispatch = useDispatch();
    const getUserProfileData = async (accessToken) => {
        const userProfileResponse = await getAutodeskUserProfile(config?.forge, accessToken);
        return userProfileResponse;
    };
    const retrieveUserContext = async (accessToken) => {
        const organizationId = getTenantId();
        const [autodeskUserContext, autodeskUserTeams, userProfile] = await Promise.all([
            retriedGetAutodeskContext(organizationId),
            getAutodeskTeams(),
            getUserProfileData(accessToken),
        ]);
        return {
            autodeskUserContext,
            autodeskUserTeams,
            userProfile,
        };
    };
    const storeUserContext = (autodeskUserContext, autodeskUserTeams, userProfile, accessToken) => {
        const { defaultSite, defaultSiteName, teams, userContext } = processUserContextToStore({
            autodeskUserContext,
            autodeskUserTeams,
            userProfile,
            accessToken,
        });
        dispatch(setUser(userProfile));
        dispatch(setTeams(teams));
        dispatch(setDefaultSite(defaultSite));
        dispatch(setDefaultSiteName(defaultSiteName));
        dispatch(setToken(accessToken));
        setTenantId(defaultSite);
        dispatch(setUserContext(userContext));
    };
    return { retrieveUserContext, storeUserContext };
};
